export default "__VITE_PUBLIC_ASSET__5cb4ac47__"